import React from 'react'
import styled from 'styled-components'
import { Box } from '../../UI/Box'

const ProgressBar = ({
  pctProgress,
  leftCircleAmount,
  h,
  RightItem,
}: {
  pctProgress: number
  leftCircleAmount?: number
  h?: number
  RightItem?: React.FC
}) => {
  return (
    <Container h={h}>
      {leftCircleAmount && <LeftCircle>{leftCircleAmount}</LeftCircle>}
      <ProgressTrack width={pctProgress} />
      <BarTrack h={h} />
      {RightItem && <RightItem />}
    </Container>
  )
}

const BarTrack = styled.div<{ h?: number }>`
  position: absolute;
  left: 0;
  border-radius: var(--units-88, 88px);
  height: var(--units-12, 12px);
  width: 100%;
  background: var(--surface-minimal-primary, rgba(255, 255, 255, 0.06));
  transition: width 0.3s ease-in-out;
  min-height: ${({ h }) => h ?? 12}px;
`

const ProgressTrack = styled(BarTrack)<{ width: number }>`
  width: ${({ width }) => width}%;
  background: var(--surface-brand, #ff0);
  transition: width 0.3s ease-in-out;
`

const Container = styled(Box)<{ h?: number }>`
  position: relative;
  align-items: center;
  min-height: ${({ h }) => (!!h ? h + 14 : 34)}px;
`

const LeftCircle = styled(Box)`
  position: absolute;
  align-items: center;
  justify-content: center;
  left: 0;
  background: var(--surface-brand, #ff0);
  z-index: 2;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  color: var(--text-invert, #080808);
  text-align: center;
  text-overflow: ellipsis;
  font-family: var(--type-family-proxima-nova, 'proxima nova');
  font-size: 17.014px;
  font-style: normal;
  font-weight: 900;
  line-height: 17.014px; /* 100% */
  text-transform: uppercase;
  filter: drop-shadow(0px 4.533px 27.2px rgba(0, 0, 0, 0.8));
`

export default ProgressBar
